// these are all on the chopping block, once we remove popper.js, bootstrap, and the 2 frameworks we can remove jquery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';
import 'popper.js';


require('../../../../modules/system/assets/js/framework.js');
require('../../../../modules/system/assets/js/framework.extras.js');

